import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: Array<{ value: string; label: string }>;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, label, error, id, options, ...props }, ref) => {
    return (
      <div className="space-y-1.5">
        {label && (
          <label htmlFor={id} className="block text-sm font-medium text-[color:var(--ink-base)]">
            {label}
          </label>
        )}
        <select
          ref={ref}
          id={id}
          className={cn(
            'block w-full rounded-[1.15rem] border border-[color:var(--surface-line)] bg-[var(--surface-panel-strong)] px-4 py-2.5 text-sm text-[color:var(--ink-strong)] shadow-[var(--shadow-soft)] transition-all focus:border-[color:var(--surface-line-strong)] focus:outline-none focus:ring-2 focus:ring-[color:var(--surface-focus)] disabled:cursor-not-allowed disabled:opacity-60',
            error && 'border-error focus:border-error focus:ring-error',
            className,
          )}
          {...props}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        {error && <p className="text-xs text-error">{error}</p>}
      </div>
    );
  },
);

Select.displayName = 'Select';
